module.exports = __webpack_public_path__ + "static/media/01.d7ce1b46.png";